<template>
  <router-view></router-view>
</template>


<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
@font-face {
  font-family: "Austie Bost Chunky Description";
  src: local("Austie Bost Chunky Description"),   url(/assets/font/pvu.ttf) format("truetype");}
</style>